var map = {
	"./barcode1.png": "6fdd",
	"./barcode2.png": "f8eb",
	"./paper_single.jpg": "a32b",
	"./pink-home.png": "d8a9",
	"./pink-order.png": "84ee",
	"./qrcode1.png": "5abb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e4e";